module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/configuracao-dashboard/configuracao-dashboard.component.scss
// module id = ./src/app/shared/componentes/configuracao-dashboard/configuracao-dashboard.component.scss
// module chunks = main